import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const adminExpiredProductsRequestRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/expired_products_requests/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import(
    'pages/admin/ExpiredProductsRequests/AdminExpiredProductsRequestPage/AdminExpiredProductsRequestPage'
  ).then((d) => d.Route)
);
